<template>
  <div
    class="button d-flex justify-content-center align-items-center px-3 py-input my-2"
    @click="$emit('click')"
  >
    <img
      src="https://cdn.vexels.com/img/google-icon.svg"
      width="25"
      :alt="$t('profile.logIn.main.googleIconAlt')"
      srcset=""
      class="mr-1"
    />
    <span v-if="login"
      >{{ $t('profile.logIn.main.logInWith') }} <span class="font-weight-bold">google</span></span
    >
    <span v-else
      >{{ $t('profile.signUp.main.signUpWith') }} <span class="font-weight-bold">google</span></span
    >
  </div>
</template>

<script>
export default {
  props: {
    login: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  color: gray;
  cursor: pointer;
  border-radius: 30px;
  background-color: $lightGray;
  span {
    font-size: 12px;
    white-space: nowrap;
  }
}
</style>
